import { motion } from 'framer-motion';

export const ContactHero = () => (
  <section className="py-24 bg-[#f8fafc]" data-testid="contact-hero">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-3xl mx-auto"
      >
        <span className="inline-block px-4 py-2 bg-white rounded-full text-sm font-medium text-[#3b5998] mb-6 shadow-sm">
          Contact Us
        </span>
        <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[#0f172a] leading-tight mb-6">
          Let's Discuss Your
          <span className="gradient-text block">Financial Goals</span>
        </h1>
        <p className="text-lg text-[#64748b] leading-relaxed">
          Schedule a consultation with our experts and discover how we can help 
          you access government subsidies and optimal financing solutions.
        </p>
      </motion.div>
    </div>
  </section>
);
